import { Injectable } from '@angular/core';
import { SettingsClassificationTypeResponseModel } from '../shared/models/response/settings/settings-classificationtype-response-model';
import { BaseService } from '../shared/services/base.service';
import { WebStorageService } from '../shared/services/web-storage.service';
import { HttpClient } from '@angular/common/http';
import { Onboard } from '../interfaces/onboard';
import { ResultOfT } from '../shared/models/response/result';

@Injectable({
  providedIn: 'root'
})
export class OnboardService extends BaseService {
  ctrl = 'onboard';
  constructor(httpService: HttpClient, webStorageService: WebStorageService) {
    super(httpService, webStorageService);
  }

  save(item: SettingsClassificationTypeResponseModel) {
    return this.post(this.ctrl, item);
  }

  deleteById(id: number) {
    return this.delete(`${this.ctrl}/${id}`);
  }

  getById(id: number) {
    return this.get(`${this.ctrl}/${id}`);
  }

  getAll() {
    return this.get<ResultOfT<Onboard[]>>(this.ctrl);
  }

  getTemplate() {
    return this.getBlob(`${this.ctrl}/template`);
  }

  getFile(onboardId: number) {
    return this.getBlob(`${this.ctrl}/${onboardId}/file`);
  }
}
